import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div className="copyright">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="payment-logo mb-md-20">
              <span className="text-custom-white fs-14 mr-3">We accept</span>
              <div className="payment-icon">
                <img src="assets/images/footer-bottom-img.png" alt="Payment methods" />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <p className="text-custom-white no-margin">
              © Ventura County Credit Union - 2024 | All Right Reserved
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
